import newLodop from "./newlodop";
import { tailFun, getPayText, getArCode } from '../money.js';
import dayjs from 'dayjs';
var keyList=[
        {
            key:'门店Logo',
            value:'logo'
        },
        {
            key:'门店名称',
            value:'shopName'
        },
        {
            key:'小票名称',
            value:'receiptName'
        },
        {
            key:'订单编号',
            value:'orderNo'
        },
        {
            key:'销售日期',
            value:'createTime'
        },
        {
            key:'收银员',
            value:'cashier'
        },
        {
            key:'销售商品明细',
            value:'items'
        },
        {
            key:'销售商品小计',
            value:'num'
        },
        {
            key:'订单优惠明细',
            value:'orderDiscountDetail'
        },
        {
            key:'订单实收金额',
            value:'actualPayment'
        },
        {
            key:'订单支付明细',
            value:'payDetail'
        },
        {
            key:'会员信息',
            value:'memberInfo'
        },
        {
            key:'联系人',
            value:'contactName'
        },
        {
            key:'联系电话',
            value:'contactPhone'
        },
        {
            key:'地址',
            value:'contactAddress'
        },
        {
            key:'分割线',
            value:'receiptLine'
        },
        {
            key:'订单条码',
            value:'orderCode'
        },
        {
            key:'店铺二维码',
            value:'qrCode'
        },
        {
            key:'自定义',
            value:'diy'
        },
        {
            key:'订单备注',
            value:'remark'
        },
      ]
var keyListLabel=[
            {
                key:'门店名称',
                value:'shopName'
            },
            {
                key:'货号',
                value:'articleNo'
            },
            {
                key:'品名',
                value:'name'
            },
            {
                key:'分类',
                value:'goodsClassName'
            },
            {
                key:'零售价',
                value:'sellingPrice'
            },
            {
                key:'折扣价',
                value:'discountPrice',
            },
            {
                key:'会员价',
                value:'memberPriceRange',
            },
            {
                key:'规格',
                value:'goodsSpecsName'
            },
            {
                key:'供应商',
                value:'supplierName',
            },
            {
                key:'商品材质',
                value:'material',
            },
            {
                key:'质量等级',
                value:'qualityLevel'
            },
            {
                key:'安全等级',
                value:'safetyLevel'
            },
            {
                key:'洗涤方式',
                value:'washingMethod'
            },
            {
                key:'执行标准',
                value:'standard'
            },
            {
                key:'商品说明',
                value:'goodsDesc'
            },
            {
                key:'条形码',
                value:'shortBarCode'
            },
            {
                key:'自定义',
                value:'diy'
            },
            {
                key:'售价',
                value:'sellingPrice'
            },
            {
                key:'洗涤小贴士',
                value:'xdTip'
            },
        ]
   var fhColumns=[
            {
               name:'人民币￥' ,
               value:'¥' ,
               hdVal:1,
            },
            {
               name:'美元$' ,
               value:'＄' ,
               hdVal:2,
            },
            {
               name:'港币HK$' ,
               value:'HK＄' ,
               hdVal:3,
            },
            {
               name:'澳门币MOP$' ,
               value:'MOP＄' ,
               hdVal:4,
            },
            {
               name:'令吉RM' ,
               value:'RM' ,
               hdVal:5,
            },
            {
               name:'台币NT$' ,
               value:'NT＄' ,
               hdVal:6,
            },
            {
                label:'阿曼OMR',
                value:'OMR',
                hdVal:7,
            },
            {
                label:'泰铢THB',
                value:'THB',
                hdVal:8,
            },
        ]
var getXpNr=async function(settingContent){
        let arr= [];
        let fh = settingContent.receiptTemplateMore.isPrintCurrency?settingContent.receiptTemplateMore.labelCurrencyType ? fhColumns.find(v=>v.hdVal==settingContent.receiptTemplateMore.labelCurrencyType).value : '':'';
        settingContent.receiptDatas.filter(v=>v.isSelect).forEach(v=>{
            let key = keyList.some(j=>j.key==v.key)?keyList.find(j=>j.key==v.key).value:''
            let receiptTemplateDataType = v.receiptTemplateDataType;
            let mh = receiptTemplateDataType==2?'':v.key=='会员信息'?'':':'
            arr.push({
                name:v.infoIsShow&&v.value?v.value+mh:'',
                value:key,
                infoIsShow:v.infoIsShow,
                defaultVal:v.info,
                size:v.size?v.size==2?22:v.size==1?11:11:11,
                fh:fh,
                dataType:v.lableValueType,/**1:系统，2：自定义 */
                receiptTemplateDataType:receiptTemplateDataType,
                alignmentType:v.alignmentType==2?'left':'center'
            })
        })
        arr=arr.map((v,index)=>{
            return{
                ...v,
                index:index
            }
        })
        return arr;
    }
var  get30Nr=async function(settingContent){
        let arr= [];
        let fh = settingContent.currency?settingContent.currency.value ? settingContent.currency.value=='¥'?'￥':settingContent.currency.value : '': '';
        if(settingContent.shopName.isSelect){
            arr.push({
                name:'',
                value:'shopName'
            });
        }
        if(settingContent.number.isSelect){
            arr.push({
                name:'条码:',
                value:'barCode'
            });
        }
        if(settingContent.name.isSelect){
            arr.push({
                name:'品名:',
                value:'name'
            });
        }
        if(settingContent.specifications.isSelect){
            arr.push({
                name:'规格:',
                value:'goodsSpecsName'
            });
        }
        if(settingContent.retailPrice.isSelect){
            arr.push({
                name:'零售价:'+fh,
                value:'sellingPrice'
            });
        }
        if(settingContent.goodsNum.isSelect==true){
            arr.push({
                name:'xs',
                value:'shortBarCode',
            });
        }
        if(settingContent.goodsNum.isSelect==false){
            arr.push({
                name:'bxs',
                value:'shortBarCode',
            });
        }
        arr=arr.map((v,index)=>{
            return{
                ...v,
                index:index
            }
        })
        return arr;
    }
var  get60Nr=async function(settingContent){
        let arr= [];
        let moreInfo= [];
        let washArr= [];
        let fh = settingContent.currency? settingContent.currency.value ? settingContent.currency.value=='¥'?'￥':settingContent.currency.value : '': ''; 
        if((settingContent.shopName&&settingContent.shopName.isSelect)||settingContent.shopName==null){
            arr.push({
                name:'',
                value:'shopName'
            });
        }
        if((settingContent.number&&settingContent.number.isSelect)||settingContent.number==null){
            arr.push({
                name:'条码:',
                value:'barCode'
            });
        }
        if((settingContent.name&&settingContent.name.isSelect)||settingContent.name==null){
            arr.push({
                name:'品名:',
                value:'name'
            });
        }
        if((settingContent.specifications&&settingContent.specifications.isSelect)||settingContent.specifications==null){
            arr.push({
                name:'规格:',
                value:'goodsSpecsName'
            });
        }
        if((settingContent.supplier&&settingContent.supplier.isSelect)||settingContent.supplier==null){
            arr.push({
                name:'供应商:',
                value:'supplierName'
            });
        }
        if((settingContent.goodsClass&&settingContent.goodsClass.isSelect)||settingContent.goodsClass==null){
            moreInfo.push({
                name:'商品分类:',
                value:'goodsClassName'
            });
        }
        if((settingContent.safetyLevel&&settingContent.safetyLevel.isSelect)||settingContent.safetyLevel==null){
            moreInfo.push({
                name:'安全等级:',
                value:'safetyLevel'
            });
        }
        if((settingContent.material&&settingContent.material.isSelect)||settingContent.material==null){
            moreInfo.push({
                name:'商品材质:',
                value:'material'
            });
        }
        if((settingContent.qualityLevel&&settingContent.qualityLevel.isSelect)||settingContent.qualityLevel==null){
            moreInfo.push({
                name:'质量等级:',
                value:'qualityLevel'
            });
        }
        if((settingContent.standard&&settingContent.standard.isSelect)||settingContent.standard==null){
            moreInfo.push({
                name:'执行标准:',
                value:'standard'
            });
        }
        if((settingContent.washingMethod&&settingContent.washingMethod.isSelect)||settingContent.washingMethod==null){
            moreInfo.push({
                name:'',
                value:'washingMethod'
            });
        }
        
        
        // moreInfo= moreInfo.length>4?moreInfo.slice(0,4):moreInfo;
        if(moreInfo.some(v=>v.value=='washingMethod')){
            if((settingContent.ironing&&settingContent.ironing.isSelect)||settingContent.ironing==null){
                washArr.push('中温熨烫');
            }
            if((settingContent.doNotWash&&settingContent.doNotWash.isSelect)||settingContent.doNotWash==null){
                washArr.push('不可机洗');
            }
            if((settingContent.noWring&&settingContent.noWring.isSelect)||settingContent.noWring==null){
                washArr.push('不可拧干');
            }
            // if((settingContent.doNotBleach&&settingContent.doNotBleach.isSelect)||settingContent.doNotBleach==null){
            //     washArr.push('不可氯漂');
            // }
            if((settingContent.lowTemperature&&settingContent.lowTemperature.isSelect)||settingContent.lowTemperature==null){
                washArr.push('低温手洗');
            }
            if((settingContent.dryClean&&settingContent.dryClean.isSelect)||settingContent.dryClean==null){
                washArr.push('标准干洗');
            }
        }
        washArr=washArr.length>4?washArr.slice(0,4):washArr;
        let standardWZ = moreInfo.findIndex(v=>v.value=='washingMethod');
        console.log('standardWZ',standardWZ,washArr,moreInfo);
        if(washArr.length>0){
            let washStr = washArr.join('/');
            if(standardWZ>-1){
                if(washArr.length>2){
                    moreInfo.splice(standardWZ,0,{
                        name:'洗涤方式:'+washStr.slice(0,8),
                        value:'washStr1',
                    },
                    {
                        name:washStr.slice(8),
                        value:'washStr2',
                    })
                }else{
                    moreInfo.splice(standardWZ,0,{
                        name:'洗涤方式:'+washStr.slice(0,8),
                        value:'washStr1',
                    }
                    )
                }
            }
        }
        arr = arr.concat(moreInfo)
        if(settingContent.goodsNum.isSelect==true){
            arr.push({
                name:'xs',
                value:'shortBarCode',
            });
        }
        if(settingContent.goodsNum.isSelect==false){
            arr.push({
                name:'bxs',
                value:'shortBarCode',
            });
        }
        if(settingContent.retailPrice.isSelect){
            arr.push({
                name:fh,
                value:'sellingPrice'
            });
        }
        arr=arr.map((v,index)=>{
            return{
                ...v,
                index:index
            }
        })
        console.log('arr',arr);
        return arr;
    }
var  get20Nr = async function(settingContent){
        let arr= [];
        // console.log('settingContent.currency.value',settingContent.currency.value);
        let fh = settingContent.currency?settingContent.currency.value ? settingContent.currency.value=='¥'?'￥':settingContent.currency.value : '': '';
        if(settingContent.shopName.isSelect){
            arr.push({
                name:'',
                value:'shopName'
            });
        }
        if(settingContent.name.isSelect){
            arr.push({
                name:'品名:',
                value:'name'
            });
        }
        if(settingContent.number.isSelect){
            arr.push({
                name:'货号:',
                value:'articleNo'
            });
        }
        if(settingContent.specifications.isSelect){
            arr.push({
                name:'规格:',
                value:'goodsSpecsName'
            });
        }
        if(settingContent.retailPrice.isSelect){
            arr.push({
                name:fh,
                value:'sellingPrice'
            });
        }
        if(settingContent.goodsNum.isSelect==true){
            arr.push({
                name:'xs',
                value:'shortBarCode',
            });
        }
        if(settingContent.goodsNum.isSelect==false){
            arr.push({
                name:'bxs',
                value:'shortBarCode',
            });
        }
        arr=arr.map((v,index)=>{
            return{
                ...v,
                index:index
            }
        })
        return arr;
    }
var  get30NrNew=async function(settingContent){
        let arr= [];
        let fh = settingContent.labelTemplateMore.isPrintCurrency?settingContent.labelTemplateMore.labelCurrencyType ? fhColumns.find(v=>v.hdVal==settingContent.labelTemplateMore.labelCurrencyType).value : '':'';
        settingContent.labelDatas.filter(v=>v.isSelect).forEach(v=>{
            let key = keyListLabel.some(j=>j.key==v.key)?keyListLabel.find(j=>j.key==v.key).value:''
            let labelTemplateDataType = v.labelTemplateDataType;
            let mh = labelTemplateDataType==2?'':':'
            arr.push({
                name:v.infoIsShow&&v.value?v.value+mh:'',
                value:key,
                infoIsShow:v.infoIsShow,
                defaultVal:v.info,
                size:v.size?v.size==2?18:v.size==1?9:9:9,
                fh:fh,
                dataType:v.lableValueType,/**1:系统，2：自定义 */
                labelTemplateDataType:labelTemplateDataType,
                affName:v.moreValue
            })
        })
        arr=arr.map((v,index)=>{
            return{
                ...v,
                index:index
            }
        })
        return arr;
    }
var get60NrNew = async function(settingContent){
        let arr= [];
        let moreInfo= [];
        let washArr= [];
        let fh = settingContent.labelTemplateMore.isPrintCurrency?settingContent.labelTemplateMore.labelCurrencyType ? fhColumns.find(v=>v.hdVal==settingContent.labelTemplateMore.labelCurrencyType).value : '':'';
        settingContent.labelDatas.filter(v=>v.isSelect).forEach(v=>{
            let key = keyListLabel.some(j=>j.key==v.key)?keyListLabel.find(j=>j.key==v.key).value:''
            let labelTemplateDataType = v.labelTemplateDataType;
            let mh = labelTemplateDataType==2?'':':'
            if(v.key=='洗涤小贴士'){
                let str = v.info.replaceAll(/,/g,'/');
                if(v.size==2){
                    if(str.length>=6&&str.length<=9){
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(0,6),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(6),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        
                    }else if(str.length>9&&str.length<=14){
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(0,6),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(6,12),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(12,14),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(14),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                    }else if(str.length>14){
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(0,6),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(6,12),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(12,18),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(18),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                    }else{
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str,
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                    }
                }else{
                    if(str.length>=12){
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(0,12),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str.slice(12),
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                    }else{
                        arr.push({
                            name:v.infoIsShow&&v.value?v.value+mh:'',
                            value:key,
                            infoIsShow:v.infoIsShow,
                            defaultVal:str,
                            size:v.size?v.size==2?18:v.size==1?9:9:9,
                            fh:fh,
                            dataType:v.lableValueType,/**1:系统，2：自定义 */
                            labelTemplateDataType:labelTemplateDataType,
                            affName:v.moreValue
                        })
                    }
                }
            }else{
                arr.push({
                    name:v.infoIsShow&&v.value?v.value+mh:'',
                    value:key,
                    infoIsShow:v.infoIsShow,
                    defaultVal:v.info,
                    size:v.size?v.size==2?18:v.size==1?9:9:9,
                    fh:fh,
                    dataType:v.lableValueType,/**1:系统，2：自定义 */
                    labelTemplateDataType:labelTemplateDataType,
                    affName:v.moreValue
                })
            }
        })
        arr=arr.map((v,index)=>{
            return{
                ...v,
                index:index
            }
        })
        console.log('arr',arr);
        return arr;
    }
/**判断当前索引之前，有大号文字的个数 */
var  chargeBeforeText=function(arr,index){
        let condition = (v)=>v.size == 18;
        return index==0?0:arr.slice(0, index).filter(condition).length;
    }
    /**判断当前索引之前，有条形码的个数 */
   var chargeBeforeCode=function(arr,index){
        let condition = (v)=>v.value == 'shortBarCode';
        return index==0?0:arr.slice(0, index).filter(condition).length;
    }
    var chargeBeforeCodeText=function(arr,index){
        let condition = (v)=>v.value == 'shortBarCode'&&v.infoIsShow;
        return index==0?0:arr.slice(0, index).filter(condition).length;
    }
var PrintEvent3 = async function (dataForm, barcodeImage?,putNum?,isOpen?) {
    let LODOP = newLodop.getLodop("", "");
    LODOP.SET_LICENSES("", "7C892C1B4653971D8FC8694A6670808D9F9", "", "");
    await getArCode(dataForm.orderInfo)
    console.log('收银小票数据', dataForm)
    let qrCodes = JSON.parse(localStorage.getItem('qrCodeValue'))
    if (LODOP) {
        // LODOP.PRINT_INIT("打印");
        // LODOP.SET_PRINT_PAGESIZE(3, '53mm', '', '');
        // LODOP.NewPage();
        if(isOpen){
            LODOP.SEND_PRINT_RAWDATA(String.fromCharCode(27, 112, 0, 60, 255));  
        }
        let padSetInfo = null;
        padSetInfo = dataForm.settingContent;
        let xpNr=await getXpNr(padSetInfo.contentJson);
         let fh = padSetInfo.contentJson.receiptTemplateMore.isPrintCurrency?padSetInfo.contentJson.receiptTemplateMore.labelCurrencyType ? fhColumns.find(v=>v.hdVal==padSetInfo.contentJson.receiptTemplateMore.labelCurrencyType).value : '':'';
        let nowShopName =JSON.parse(localStorage.getItem('padShopInfo')).shopName;
        let nowShop =JSON.parse(localStorage.getItem('padShopInfo'));
         let str = ''

       xpNr.forEach((rv,i)=>{
            let value = rv.dataType==1?dataForm.orderInfo[rv.value]:rv.defaultVal;
            if(rv.value=='shopName'){
            let shopName = rv.defaultVal?rv.defaultVal:nowShopName;
              str += `<div style="font-size:${rv.size}px;text-align:${rv.alignmentType};">${shopName}</div>`
            }
            else if(rv.value=='logo'){
                if(rv.defaultVal){
                    if(rv.defaultVal=='https://hfto.oss-cn-hangzhou.aliyuncs.com/cw_upload/2025/05/21/3542c594348f49648a35da517821c27b.jpg'||'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/6474B268-FC5F-460C-8B4E-B652AA23CFB0.png'){
                        str += `<div style="100%;height:50px;text-align:${rv.alignmentType};margin-bottom:10px;">
                             <img style="height:50px;background:#000;"
                                 src="${rv.defaultVal}"
                                 alt="">
                        </div>`
                    }else{
                        str += `<div style="100%;height:50px;text-align:${rv.alignmentType};margin-bottom:10px;">
                             <img style="height:50px;"
                                 src="${rv.defaultVal}"
                                 alt="">
                        </div>`
                    }
                }
                
            }else if(rv.value=='cashier'){
                str += `<div style="font-size:${rv.size}px;text-align:${rv.alignmentType};">${rv.name+dataForm.orderInfo.cashierNo+dataForm.orderInfo.cashier}</div>`
            }else if(rv.value=='receiptLine'){
                 str += `<div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>`
            }else if(rv.value=='items'){
                let strNew = ``; 
                dataForm.orderInfo.items.forEach(item => {
                let str2 = ''
                let vs = ''
                if(item.goodsSpecsName){
                    for(let i=0;i<item.goodsSpecsName.length;i++){
                        let j = ''
                        let reg = /[^\u4E00-\u9FA5]/;
                        if(!reg.test(item.goodsSpecsName[i])){
                            // console.log('字符串',item.goodsSpecsName[i])
                            vs += `<div style="display:inline-block;padding-bottom:1px;box-sizing: border-box;">${item.goodsSpecsName[i]}</div>`
                        }else{
                            vs += `${item.goodsSpecsName[i]}`
                        }
                    }
                }

                let str1 = `
                            <div style="font-size:${rv.size}px;">
                                <div style="margin-top:2px;">${item.articleNo}</div>
                                <div style="line-height:18px;display:flex;flex-wrap:wrap; align-items: flex-end;">
                                    <div style="font-size:${rv.size}px;">${item.name}</div>
                                    <div style="font-size:${rv.size}px;">${item.goodsSpecsName ? '(' + vs + ')' : ''}</div>
                                </div>
                                <div style="display:flex;margin-top:2px;">
                                    <div style="width:25%;text-align: left;"></div>
                                    <div style="width:30%;text-align: right;">${item.num}</div>
                                    <div style="width:22%;text-align: right;">${Number(item.sellingPrice).toFixed(2)}</div>
                                    <div style="width:23%;text-align: right;">${(Number(item.num) * Number(item.sellingPrice)).toFixed(2)}</div>
                                </div>
                            `
                let thPrice = Number(item.sellingPrice) - Number(item.goodsDiscount) - Number(item.memberDiscount);

                if (item.isCoupon) {
                    let str21 = ''
                    if (((item.goodsDiscount && item.goodsDiscount > 0) || (item.isMemberDiscount && item.memberDiscount > 0)) && !item.isGift) {
                        str21 = `
                            <div style="width:32%;text-align: right;font-size:${rv.size}px;">【折扣价】</div>
                            <div style="width:22%;text-align: right;font-size:${rv.size}px;">${tailFun(thPrice)}</div>
                            <div style="width:23%;text-align: right;font-size:${rv.size}px;">${tailFun(Number(item.num) * thPrice)}</div>
                            `
                    }
                    str2 = `
                                <div style="display:flex;margin-top:2px;font-size:${rv.size}px;">
                                    <div style="width:23%;text-align: left;">【惠】</div>
                                    `+ str21 + `
                                </div>
                                `
                } else {
                    if (((item.goodsDiscount && item.goodsDiscount > 0) || (item.isMemberDiscount && item.memberDiscount > 0)) && !item.isGift) {
                        str2 = `
                            <div style="display:flex;margin-top:2px;font-size:${rv.size}px;">
                                <div style="width:23%;text-align: left;"></div>
                                <div style="width:32%;text-align: right;">【折扣价】</div>
                                <div style="width:22%;text-align: right;">${tailFun(thPrice)}</div>
                                <div style="width:23%;text-align: right;">${tailFun(Number(item.num) * thPrice)}</div>
                            </div>
                            `
                    }

                }
                let str3t = ''
                if (item.isGift) {
                    str3t = `
                            <div style="display:flex;margin-top:2px;font-size:${rv.size}px;">
                                <div style="width:25%;text-align: left;">【赠】</div>
                                <div style="width:30%;text-align: right;"></div>
                                <div style="width:22%;text-align: right;">0.00</div>
                                <div style="width:23%;text-align: right;">0.00</div>
                            </div>
                            `
                }

                strNew = strNew + str1 + str2 + str3t ;
                
            })
            str+=`<div style="margin-top:5px;">
                            <div style="display:flex;font-size:12px;">
                                <div style="width:25%;text-align: left;">商品</div>
                                <div style="width:30%;text-align: center;">数量</div>
                                <div style="width:22%;text-align: center;">单价</div>
                                <div style="width:23%;text-align: center;">金额</div>
                            </div>
                            <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>`+strNew+'</div>';
            }
            else if(rv.value=='num'){
                    let orderToalarr= dataForm.orderInfo.items.filter(j=>!j.isGift).map(v=>(Number(v.sellingPrice)-Number(v.goodsDiscount)-Number(v.memberDiscount))*v.num);
                    let orderToal = orderToalarr.length>0? orderToalarr.reduce((a,b)=>tailFun(Number(a)+Number(b))):0

                    str+= `<div style="display:flex;justify-content: space-between;font-size:${rv.size}px;">
                            <div>${rv.name}</div>
                            <div>${dataForm.orderInfo.num}</div>
                            <div>${fh=='¥'?tailFun(orderToal)+'元':fh+tailFun(orderToal)}</div>
                    </div>`
                }else if(rv.value=='orderDiscountDetail'){
                    let pointDeductionStr = fh=='¥'?dataForm.orderInfo.pointDeduction+'元': fh+dataForm.orderInfo.pointDeduction;
                let orderDiscountPriceStr=fh=='¥'?dataForm.orderInfo.orderDiscountPrice+'元':fh+dataForm.orderInfo.orderDiscountPrice;
                /**整单折扣 */
                if(dataForm.orderInfo.isWholeOrderDiscount){
                  

                    str+= `<div style="font-size:${rv.size}px;">
                            ${"整单折扣："+tailFun((dataForm.orderInfo.orderDiscount*100),0)+'%'+'(折扣金额：'+orderDiscountPriceStr+')'}</div>
                            <div style="font-size:${rv.size}px;">
                            ${"积分抵扣："+(dataForm.orderInfo.useIntegral)+'(折扣金额：'+pointDeductionStr+')'}</div>`
        
                }else{
                    
                    str+= `<div style="font-size:${rv.size}px;">
                            ${"整单折扣："+'/'+'(折扣金额：'+orderDiscountPriceStr+')'}</div>
                            <div style="font-size:${rv.size}px;">
                            ${"积分抵扣："+(dataForm.orderInfo.useIntegral)+'(折扣金额：'+pointDeductionStr+')'}</div>`
                }
                if(dataForm.orderInfo.couponName){
                    let couponPriceStr = fh=='¥'?dataForm.orderInfo.couponPrice+'元':fh+dataForm.orderInfo.couponPrice;
                    let str3 ="优惠券："+(dataForm.orderInfo.couponName)+'(折扣金额：'+couponPriceStr+')';
                     str+= `<div style="font-size:${rv.size}px;"">
                            ${str3}</div>`
                }
           
            }else if(rv.value=='payDetail'){
                let ysTxt = fh=='¥'?dataForm.orderInfo.receivables+'元':fh+dataForm.orderInfo.receivables
              
                str+= `<div style="font-size:${rv.size}px;">
                            <div>${"本单应收："+ysTxt}</div>       
                            <div>${"支付方式："+getPayText(dataForm.orderInfo.paymentMethod)}</div>       
                            <div>${'找零金额：'+dataForm.orderInfo.giveChange}</div>       
                </div>`

            }else if(rv.value=='orderCode'){
                str+=`<div style="margin-top:5px;text-align:${rv.alignmentType};">
                    <img style="height:60px"
                        src="${barcodeImage}"
                        alt="">
                    <div style="font-size:11px;">${dataForm.orderInfo.orderNo}</div>
                </div>`
            }else if(rv.value=='memberInfo'){
                if(dataForm.orderInfo.memberId){
                    
                    let val =getPayText(dataForm.orderInfo.paymentMethod)=='组合'?dataForm.orderInfo.cardPart:getPayText(dataForm.orderInfo.paymentMethod)=='会员卡'?dataForm.orderInfo.receivables:0;
                  

                   str+=  `
                <div style="margin-top:5px;font-size:${rv.size}px;">
                    <div>${rv.name}</div>
                    <div>${"会员："+dataForm.orderInfo.memberPhone+`【${dataForm.orderInfo.memberDiscount}折】`}</div>
                    <div>${"余额："+dataForm.orderInfo.leftBalance+` 积分：${dataForm.orderInfo.leftIntegral}`}</div>
                    <div>${"本次消费："+val+` 本次积分：${dataForm.orderInfo.changeIntegral}`}</div>
                    
                </div>
                `
                }else{
                  
                    str+=  `
                <div style="margin-top:5px;font-size:${rv.size}px;">
                    <div>${rv.name}</div>
                </div>
                `
                }
            }else if(rv.value=='qrCode'){
                str+=`
                    <div style="margin-top:5px;text-align:${rv.alignmentType};">
                        <img style="width:100px;height:100px;"
                            src="${qrCodes}"
                            alt="">
                    </div>
                `
            }else if(rv.value=='contactName'){
                let contactName = rv.defaultVal?rv.defaultVal:nowShop.name;
               str+=`
                     <div style="margin-top:5px;text-align:${rv.alignmentType};font-size:${rv.size}px;">
                        ${rv.name+contactName}
                     </div>
                `
            }else if(rv.value=='contactPhone'){
                let contactPhone = rv.defaultVal?rv.defaultVal:nowShop.phone;
                str+=`
                     <div style="margin-top:5px;text-align:${rv.alignmentType};font-size:${rv.size}px;">
                        ${rv.name+contactPhone}
                     </div>
                `
            }else if(rv.value=='contactAddress'){
                let contactAddress = rv.defaultVal?rv.defaultVal:nowShop.address;
                str+=`
                     <div style="margin-top:5px;text-align:${rv.alignmentType};font-size:${rv.size}px;">
                        ${rv.name+contactAddress}
                     </div>
                `
            }else if(rv.value=='remark'){
                if(dataForm.orderInfo.remark){
                    str+=`
                         <div style="margin-top:5px;font-size:${rv.size}px;">
                            <div>${rv.name}</div>
                            <div>${dataForm.orderInfo.remark}</div>
                        </div>
                    `
                }
            }else{
                str+=`
                     <div style="margin-top:5px;text-align:${rv.alignmentType};font-size:${rv.size}px;">
                        ${rv.name+value}
                     </div>
                `
            }

            if(i==xpNr.length-1){
                //  command.setPrint()
                // command.setPrint()
                // command.setPrint()
                // command.setPrint()
                // that.prepareSend(command.getData())

                 var strFormHtml = `
                <body style="margin:0 auto;padding:0;font-weight:600;">
                    <div style="width:100%;">`+ str + `  </div>
                </body>`;
                LODOP.PRINT_INIT("打印");
                LODOP.SET_PRINT_MODE("WINDOW_DEFPRINTER");
                LODOP.SET_PRINT_PAGESIZE(3, '58mm', 20, '');
                LODOP.ADD_PRINT_HTM(0, 0, '100%', "100%", strFormHtml)
                LODOP.SET_PRINT_COPIES(putNum); 
                LODOP.PRINT(); //打印模式
                // LODOP.PREVIEW()
            }
      
        })
    }
};
var PrintEvent1 = async function (dataForm, barcodeImage?,isOpen?) {
    let LODOP = newLodop.getLodop("", "");
    LODOP.SET_LICENSES("", "7C892C1B4653971D8FC8694A6670808D9F9", "", "");
    await getArCode(dataForm.orderInfo)
    console.log('收银小票数据', dataForm)
    let qrCodes = JSON.parse(localStorage.getItem('qrCodeValue'))
    if (LODOP) {
        // LODOP.PRINT_INIT("打印");
        // LODOP.SET_PRINT_PAGESIZE(3, '53mm', '', '');
        // LODOP.NewPage();
        if(isOpen){
            LODOP.SEND_PRINT_RAWDATA(String.fromCharCode(27, 112, 0, 60, 255));  
        }
        let strNew = ''

        dataForm.orderInfo.items.forEach(item => {
            let str2 = ''
            let vs = ''
            if(item.goodsSpecsName){
                for(let i=0;i<item.goodsSpecsName.length;i++){
                    let j = ''
                    let reg = /[^\u4E00-\u9FA5]/;
                    if(!reg.test(item.goodsSpecsName[i])){
                        // console.log('字符串',item.goodsSpecsName[i])
                        vs += `<div style="display:inline-block;padding-bottom:1px;box-sizing: border-box;">${item.goodsSpecsName[i]}</div>`
                    }else{
                        vs += `${item.goodsSpecsName[i]}`
                    }
                }
            }

            let str1 = `
                        <div >
                            <div style="margin-top:2px;">${item.articleNo}</div>
                            <div style="line-height:18px;display:flex;flex-wrap:wrap; align-items: flex-end;">
                                <div >${item.name}</div>
                                <div >${item.goodsSpecsName ? '(' + vs + ')' : ''}</div>
                            </div>
                            <div style="display:flex;margin-top:2px;">
                                <div style="width:25%;text-align: right;"></div>
                                <div style="width:30%;text-align: right;">${item.num}</div>
                                <div style="width:22%;text-align: right;">${Number(item.sellingPrice).toFixed(2)}</div>
                                <div style="width:23%;text-align: right;">${(Number(item.num) * Number(item.sellingPrice)).toFixed(2)}</div>
                            </div>
                        `
            let thPrice = Number(item.sellingPrice) - Number(item.goodsDiscount) - Number(item.memberDiscount);

            if (item.isCoupon) {
                let str21 = ''
                if (((item.goodsDiscount && item.goodsDiscount > 0) || (item.isMemberDiscount && item.memberDiscount > 0)) && !item.isGift) {
                    str21 = `
                        <div style="width:32%;text-align: right;">【折扣价】</div>
                        <div style="width:22%;text-align: right;">${tailFun(thPrice)}</div>
                        <div style="width:23%;text-align: right;">${tailFun(Number(item.num) * thPrice)}</div>
                        `
                }
                str2 = `
                            <div style="display:flex;margin-top:2px;">
                                <div style="width:23%;text-align: left;">【惠】</div>
                                `+ str21 + `
                            </div>
                            `
            } else {
                if (((item.goodsDiscount && item.goodsDiscount > 0) || (item.isMemberDiscount && item.memberDiscount > 0)) && !item.isGift) {
                    str2 = `
                        <div style="display:flex;margin-top:2px;">
                            <div style="width:23%;text-align: right;"></div>
                            <div style="width:32%;text-align: right;">【折扣价】</div>
                            <div style="width:22%;text-align: right;">${tailFun(thPrice)}</div>
                            <div style="width:23%;text-align: right;">${tailFun(Number(item.num) * thPrice)}</div>
                        </div>
                        `
                }

            }
            let str3t = ''
            if (item.isGift) {
                str3t = `
                        <div style="display:flex;margin-top:2px;">
                            <div style="width:25%;text-align: left;">【赠】</div>
                            <div style="width:30%;text-align: center;"></div>
                            <div style="width:22%;text-align: right;">0.00</div>
                            <div style="width:23%;text-align: right;">0.00</div>
                        </div>
                        `
            }

            strNew = strNew + str1 + str2 + str3t + ` </div> `
        })
        // 店铺名
        let shopName = ''
        if (dataForm.settingContent.shopName.isSelect) {
            shopName = `<div style="text-align: center;margin: 0 0 5px;font-weight:bold;">
                ${dataForm.settingContent.shopName.value}</div>`
        }
        // 折扣
        let str3 = ''
        if (dataForm.settingContent.payInfo && dataForm.settingContent.payInfo.isSelect) {

            let str31 = `<div style="margin-top:5px;">
                    <div >
                        <div style="display:flex;margin-top:3px;">
                            <div style="margin-right:5px;">整单折扣：${dataForm.orderInfo.isWholeOrderDiscount ? tailFun((dataForm.orderInfo.orderDiscount * 100), 0) + '%' : '/'}
                             (折扣金额：-${dataForm.settingContent.currency.value}${dataForm.orderInfo.orderDiscountPrice.toFixed(2)})
                            </div>
                           
                        </div>
                        <div style="display:flex;margin-top:3px;">
                            <div style="margin-right:5px;">积分抵扣：${dataForm.orderInfo.useIntegral}</div>
                            <div style="">
                                (抵扣金额：-${dataForm.settingContent.currency.value}${dataForm.orderInfo.pointDeduction.toFixed(2)})
                            </div>
                        </div>
                        `
            let str32 = dataForm.orderInfo.couponName ? `
                        <div style="display:flex;margin-top:3px;">
                            优惠券：${dataForm.orderInfo.couponName ? dataForm.orderInfo.couponName : ''}
                            (抵扣金额：-${dataForm.settingContent.currency.value}${dataForm.orderInfo.couponPrice.toFixed(2)})
                        </div>
                       
                        `: ''

            let str33 = `
                    </div>
                    <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                    <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                    <div style="">
                        <div style="display:flex;margin-top:5px;justify-content: space-between;">
                            <span style="text-align:left;">应收</span>
                            <span style="text-align:right;padding-right:5px;box-sizing: border-box;">
                                ${dataForm.settingContent.currency.value}${dataForm.orderInfo.receivables.toFixed(2)}
                            </span>
                        </div>
                        <div style="display:flex;margin-top:5px;justify-content: space-between;">
                            <span style="text-align:left;">支付方式：${getPayText(dataForm.orderInfo.paymentMethod)}</span>
                            <span style="text-align:right;padding-right:5px;box-sizing: border-box;">现金找零：${dataForm.orderInfo.giveChange.toFixed(2)}</span>
                        </div>
                    </div>
                </div>`
            str3 = str31 + str32 + str33
        }
        // 店铺条形码
        let barCode = ''
        if (dataForm.settingContent.orderCode.isSelect) {
            barCode = `
                <div style="margin-top:5px;text-align:center;">
                    <img style="height:60px"
                        src="${barcodeImage}"
                        alt="">
                    <div >${dataForm.orderInfo.orderNo}</div>
                </div>
                `
        }
        // 会员信息
        let menberInfo = ''
        if (dataForm.settingContent.member.isSelect && dataForm.settingContent.member && dataForm.orderInfo.memberId) {
            let val = getPayText(dataForm.orderInfo.paymentMethod) == '组合' ? dataForm.orderInfo.cardPart : getPayText(dataForm.orderInfo.paymentMethod) == '会员卡' ? dataForm.orderInfo.receivables : 0;

            menberInfo = `
                <div style="margin-top:5px;">
                    <div >会员信息</div>
                    <div style="display:flex;margin-top:3px;">
                        <div style="margin-right:5px;">会员：${dataForm.orderInfo.memberPhone}</div>
                        <div>【${dataForm.orderInfo.memberDiscount}折】</div>
                    </div>
                    <div style="display:flex;margin-top:3px;">
                        <div style="margin-right:5px;">余额：${dataForm.orderInfo.leftBalance.toFixed(2)}</div>
                        <div>积分：${dataForm.orderInfo.leftIntegral}</div>
                    </div>
                    <div style="display:flex;margin-top:3px;">
                        <div style="margin-right:5px;">本次消费：${val}</div>
                        <div>本次积分：${dataForm.orderInfo.changeIntegral}</div>
                    </div>
                </div>
                `
        }
        // 订单备注
        let remarkInfo = ''
        if (dataForm.settingContent.receiptRemark.isSelect && dataForm.settingContent.receiptRemark && dataForm.orderInfo.remark) {
            remarkInfo = `
                <div style="margin-top:5px;">
                    <div >订单备注</div>
                    <div style="dmargin-top:3px;">
                        <div >${dataForm.orderInfo.remark}</div>
                    </div>
                </div>
                `
        }
        // 门店二维码
        let qrCode = ''

        if (dataForm.settingContent.qrCode.isSelect) {

            qrCode = `
                    <div style="margin-top:10px;text-align:center;">
                        <img style="width:100px;height:100px;"
                            src="${qrCodes}"
                            alt="">
                    </div>
                    <div style="text-align:center;margin-top:5px;">
                        <div>${dataForm.settingContent.qrCode.value}</div>
                    </div>
                `
        }
        let remarktxt = ""
        if(dataForm.settingContent.remark.value){
            remarktxt=` <div style="text-align:center;margin-top:5px;">${dataForm.settingContent.remark.value}</div>`
        }
        let weltxt = ""
        if(dataForm.settingContent.welcomeMessage.value){
            weltxt=`  <div style="text-align:center;margin-top:5px;">
                            ${dataForm.settingContent.welcomeMessage.value}</div>`
        }

        // 联系方式
        let contactInfo = ''
        if (dataForm.settingContent.contactInfo.isSelect) {
            contactInfo = `
                <div style="text-align:center;margin-top:10px;">${dataForm.settingContent.contactInfo.value}</div>
                `
        }
        let orderToalarr = dataForm.orderInfo.items.filter(j => !j.isGift).map(v => (Number(v.sellingPrice) - Number(v.goodsDiscount) - Number(v.memberDiscount)) * v.num);
        let orderToal = orderToalarr.length > 0 ? orderToalarr.reduce((a, b) => tailFun(Number(a) + Number(b))) : 0

        var strFormHtml = `
                <body style="margin:0 auto;padding:0;font-size:11px;font-weight:600;">
                    <div style="width:100%;">`+ shopName + `
                        <div style="text-align: center;">销售单</div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;">
                            <div style="margin-top:2px;">订单：${dataForm.orderInfo.orderNo}</div>
                            <div style="margin-top:2px;">日期：${dataForm.orderInfo.createTime}</div>
                            <div style="margin-top:2px;">收银员：
                                <div style="padding-top:3px;display:inline-block;box-sizing: border-box;">${dataForm.orderInfo.cashierNo}</div>
                                ${dataForm.orderInfo.cashier}
                            </div>
                        </div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;">
                            <div style="display:flex;">
                                <div style="width:25%;text-align: left;">商品</div>
                                <div style="width:30%;text-align: center;">数量</div>
                                <div style="width:22%;text-align: center;">单价</div>
                                <div style="width:23%;text-align: center;">金额</div>
                            </div>
                            `
            + strNew +
            `
                        </div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="display:flex;justify-content: space-between;margin-top:5px;">
                            <div ">小计</div>
                            <div ">${dataForm.orderInfo.num}</div>
                            <div ">
                                ${dataForm.settingContent.currency.value}${tailFun(orderToal)}</div>
                        </div>
                        `
            + str3 +
            `
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        `
            + barCode + menberInfo+remarkInfo +
            `
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;">
                        `
            + shopName +
            `  
                            <div style="text-align:center;margin-top:10px;">${dataForm.orderInfo.address}</div>
                        `
            + contactInfo +
            `   
                            <div style="text-align:center;margin-top:5px;">本店营业时间：${dataForm.settingContent.businessHours.value}</div>
                        `
            + qrCode +
            `  
                        </div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                       `
                       +remarktxt+weltxt+
                       `
                    </div>
                </body>
            ` //获取打印内容
        // LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml)
        // console.log('strFormHtml',strFormHtml);
        LODOP.PRINT_INIT("打印");
        LODOP.SET_PRINT_MODE("WINDOW_DEFPRINTER");
        LODOP.SET_PRINT_PAGESIZE(3, '58mm', 20, '');
        LODOP.ADD_PRINT_HTM(0, 0, '100%', "100%", strFormHtml)
        // LODOP.PREVIEW()
        LODOP.PRINT(); //打印模式
        
    }
};
var PrintEvent2 = async function (dataForm,isOpen?) {
    let LODOP = newLodop.getLodop("", "");
    LODOP.SET_LICENSES("", "7C892C1B4653971D8FC8694A6670808D9F9", "", "");
    console.log('充值数据', dataForm)
    if (LODOP) {
        // LODOP.PRINT_INIT("打印");
        // LODOP.SET_PRINT_PAGESIZE(1, '53mm', '95mm', 'A4');
        // LODOP.NewPage();
        // 店铺名
        if(isOpen){
            LODOP.SEND_PRINT_RAWDATA(String.fromCharCode(27, 112, 0, 60, 255));  
        }
        let shopName = ''
        if (dataForm.settingContent.shopName.isSelect) {
            shopName = `<div style="text-align: center;margin: 0 0 5px;font-weight:bold;">
            ${dataForm.settingContent.shopName.value}</div>`
        }
        // 日期
        let orderDate = ''
        if (dataForm.settingContent.dateTime.isSelect) {
            orderDate = `<div style="line-height:15px;">
                        日期：${dataForm.orderInfo.orderDate}
                    </div>
                    `
        }
        // 会员
        let member = ''
        if (dataForm.settingContent.member.isSelect) {
            member = `<div style="line-height:15px;">
                        会员：${dataForm.orderInfo.memberPhone}
                    </div>
                    `
        }

        // 店铺信息
        let address = ''
        if (dataForm.settingContent.shopInfo.isSelect) {
            address = `<div style="margin-top:5px;font-size:11px">
                            ${dataForm.orderInfo.address}
                        </div>
                    `
        }
        // 营业时间
        let businessHours = ''
        if (dataForm.settingContent.businessHours.isSelect) {
            businessHours = `<div style="margin-top:5px;font-size:11px">
                                本店营业时间：${dataForm.settingContent.businessHours.value}
                            </div>
                    `
        }
        // 欢迎语
        let welcomeMessage = ''
        if (dataForm.settingContent.welcomeMessage.isSelect) {
            welcomeMessage = `<div style="margin-top:5px;font-size:12px;">
                                    ${dataForm.settingContent.welcomeMessage.value}
                                </div>
                     `
        }
        var strFormHtml = `
            <body style="margin:0;padding:0;font-weight:600">
                <div style="width:49mm;margin:5px 0;">
                `+ shopName + `
                    <div style="text-align: center;">会员充值凭证</div>
                    <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                    <div style="margin-top:5px;font-size:11px">
                        <div style="line-height:15px;">订单：${dataForm.orderInfo.orderNo}</div>
                        `+ orderDate + member + `
                        <div style="line-height:15px;">收银员：${dataForm.orderInfo.cashierName}</div>
                    </div>
                    <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                    <div style="margin-top:5px;font-size:11px">
                        <div style="line-height:15px;">充前金额：
                            ${dataForm.settingContent.currency.value}
                            ${tailFun(dataForm.orderInfo.originalAmount)}
                        </div>
                        <div style="line-height:15px;">充值金额：
                            ${dataForm.settingContent.currency.value}
                            ${tailFun(dataForm.orderInfo.rechargeAmount)}
                        </div>
                        <div style="line-height:15px;">赠送金额：
                            ${dataForm.settingContent.currency.value}
                            ${tailFun(dataForm.orderInfo.giftAmount)}
                        </div>
                        <div style="line-height:15px;">赠送积分：${dataForm.orderInfo.giftIntegral}</div>
                        <div style="line-height:15px;">现有金额：
                            ${dataForm.settingContent.currency.value}
                            ${tailFun(dataForm.orderInfo.currentAmount)}
                        </div>
                        <div style="line-height:15px;">现有积分：${dataForm.orderInfo.currentIntegral}</div>
                    </div>
                    <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                    <div style="font-size:11px">
                        <div style="display:flex;justify-content: space-between;margin-top:5px;">
                            <div style="width:50%;">应收：${tailFun(dataForm.orderInfo.receivedAmount)}</div>
                            <div style="width:50%;">实收：${tailFun(dataForm.orderInfo.receivedAmount)}</div>
                        </div>
                        <div style="display:flex;justify-content: space-between;margin-top:5px;">
                            <div style="width:50%;">支付方式：${getPayText(dataForm.orderInfo.paymentMethod)}</div>
                            <div style="width:50%;">找零金额：${tailFun(dataForm.orderInfo.giveChange)}</div>
                        </div>
                    </div>
                    <div style="margin:5px 0;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                    <div style="font-size:11px;">
                    `+ shopName + address + businessHours + welcomeMessage + `
                    </div>
                </div>
            </body>
        `
        //获取打印内容
        LODOP.PRINT_INIT("打印");
        LODOP.SET_PRINT_MODE("WINDOW_DEFPRINTER");
        LODOP.SET_PRINT_PAGESIZE(1, '58mm', '95mm', 'A4');
        LODOP.NewPage();
        LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml)
        // LODOP.PREVIEW()
        LODOP.PRINT(); //打印模式
        // LODOP.PRINT_SETUP()
    }
}
var PrintEvent4 = async function (dataForm) {
    let LODOP = newLodop.getLodop("", "");
    LODOP.SET_LICENSES("", "7C892C1B4653971D8FC8694A6670808D9F9", "", "");
    let shopName2 = JSON.parse(localStorage.getItem('padShopInfo')).shopName;
    await getArCode(dataForm.orderInfo)
    console.log('收银小票数据', dataForm)
    let qrCodes = JSON.parse(localStorage.getItem('qrCodeValue'))
    if (LODOP) {
        // LODOP.PRINT_INIT("打印");
        // LODOP.SET_PRINT_PAGESIZE(3, '53mm', '', '');
        // LODOP.NewPage();

        let strNew = ''

        dataForm.orderInfo.items.forEach(item => {
            let str2 = ''
            let vs = ''
            if(item.goodsSpecsName){
                for(let i=0;i<item.goodsSpecsName.length;i++){
                    let j = ''
                    let reg = /[^\u4E00-\u9FA5]/;
                    if(!reg.test(item.goodsSpecsName[i])){
                        // console.log('字符串',item.goodsSpecsName[i])
                        vs += `<div style="display:inline-block;padding-bottom:1px;box-sizing: border-box;">${item.goodsSpecsName[i]}</div>`
                    }else{
                        vs += `${item.goodsSpecsName[i]}`
                    }
                }
            }

            let str1 = `
                        <div >
                            <div style="margin-top:2px;">${item.articleNo}</div>
                            <div style="line-height:18px;display:flex;flex-wrap:wrap; align-items: flex-end;">
                                <div >${item.name}</div>
                                <div >${item.goodsSpecsName ? '(' + vs + ')' : ''}</div>
                            </div>
                            <div style="display:flex;margin-top:2px;">
                                <div style="width:25%;text-align: right;"></div>
                                <div style="width:30%;text-align: right;">${item.num}</div>
                                <div style="width:22%;text-align: right;">${Number(item.sellingPrice).toFixed(2)}</div>
                                <div style="width:23%;text-align: right;">${(Number(item.num) * Number(item.sellingPrice)).toFixed(2)}</div>
                            </div>
                        `
            let thPrice = Number(item.sellingPrice) - Number(item.goodsDiscount) - Number(item.memberDiscount);

            if (item.isCoupon) {
                let str21 = ''
                if (((item.goodsDiscount && item.goodsDiscount > 0) || (item.isMemberDiscount && item.memberDiscount > 0)) && !item.isGift) {
                    str21 = `
                        <div style="width:32%;text-align: right;">【折扣价】</div>
                        <div style="width:22%;text-align: right;">${tailFun(item.discountedPrice)}</div>
                        <div style="width:23%;text-align: right;">${tailFun(item.totalPrice)}</div>
                        `
                }
                str2 = `
                            <div style="display:flex;margin-top:2px;">
                                <div style="width:23%;text-align: left;">【惠】</div>
                                `+ str21 + `
                            </div>
                            `
            } else {
                if (((item.goodsDiscount && item.goodsDiscount > 0) || (item.isMemberDiscount && item.memberDiscount > 0)) && !item.isGift) {
                    str2 = `
                        <div style="display:flex;margin-top:2px;">
                            <div style="width:23%;text-align: right;"></div>
                            <div style="width:32%;text-align: right;">【折扣价】</div>
                            <div style="width:22%;text-align: right;">${tailFun(item.discountedPrice)}</div>
                            <div style="width:23%;text-align: right;">${tailFun(item.totalPrice)}</div>
                        </div>
                        `
                }

            }
            let str3t = ''
            if (item.isGift) {
                str3t = `
                        <div style="display:flex;margin-top:2px;">
                            <div style="width:25%;text-align: left;">【赠】</div>
                            <div style="width:30%;text-align: center;"></div>
                            <div style="width:22%;text-align: right;">0.00</div>
                            <div style="width:23%;text-align: right;">0.00</div>
                        </div>
                        `
            }

            strNew = strNew + str1 + str2 + str3t + ` </div> `
        })
        // 店铺名
        let shopName = ''
        
        shopName = `<div style="text-align: center;margin: 0 0 5px;font-weight:bold;">
            ${dataForm.orderInfo.shopName}</div>`
      
       let str33 = `
                    <div style="">
                        <div style="display:flex;margin-top:5px;justify-content: space-between;">
                            <span style="text-align:left;">实收</span>
                            <span style="text-align:right;padding-right:5px;box-sizing: border-box;">
                              ${dataForm.orderInfo.actualPayment.toFixed(2)}
                            </span>
                        </div>
                        <div style="display:flex;margin-top:5px;justify-content: space-between;">
                            <span style="text-align:left;">支付方式：${getPayText(dataForm.orderInfo.paymentMethod)}</span>
                        </div>
                    </div>
                    <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                `;
        // 会员信息
        let menberInfo = ''
        if ( dataForm.orderInfo.memberId) {
            let val = getPayText(dataForm.orderInfo.paymentMethod) == '组合' ? dataForm.orderInfo.cardPart : getPayText(dataForm.orderInfo.paymentMethod) == '会员卡' ? dataForm.orderInfo.receivables : 0;

            menberInfo = `
                <div style="margin-top:5px;">
                    <div >会员信息</div>
                    <div style="display:flex;margin-top:3px;">
                        <div style="margin-right:5px;">会员：${dataForm.orderInfo.memberPhone}</div>
                        <div>【${dataForm.orderInfo.memberDiscount}折】</div>
                    </div>
                    <div style="display:flex;margin-top:3px;">
                        <div style="margin-right:5px;">余额：${dataForm.orderInfo.leftBalance.toFixed(2)}</div>
                        <div>积分：${dataForm.orderInfo.leftIntegral}</div>
                    </div>
                    <div style="display:flex;margin-top:3px;">
                        <div style="margin-right:5px;">本次消费：${val}</div>
                        <div>本次积分：${dataForm.orderInfo.changeIntegral}</div>
                    </div>
                </div>
                `
        }
        // 订单备注
        let remarkInfo = ''
        if (dataForm.orderInfo.remarks) {
            remarkInfo = `
                <div style="margin-top:5px;">
                    <div >订单备注</div>
                    <div style="dmargin-top:3px;">
                        <div >${dataForm.orderInfo.remarks}</div>
                    </div>
                </div>
                `
        }

        
        let orderToalarr = dataForm.orderInfo.items.filter(j => !j.isGift).map(v => (Number(v.sellingPrice) - Number(v.goodsDiscount) - Number(v.memberDiscount)) * v.num);
        let orderToal = orderToalarr.length > 0 ? orderToalarr.reduce((a, b) => tailFun(Number(a) + Number(b))) : 0

        var strFormHtml = `
                <body style="margin:0 auto;padding:0;font-size:11px;font-weight:600">
                    <div style="width:100%;">`+ shopName + `
                        <div style="text-align: center;">网店订单</div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;">
                            <div style="margin-top:2px;">订单：${dataForm.orderInfo.orderNo}</div>
                            <div style="margin-top:2px;">日期：${dataForm.orderInfo.orderDate}</div>
                        </div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;">
                            <div style="display:flex;">
                                <div style="width:25%;text-align: left;">商品</div>
                                <div style="width:30%;text-align: center;">数量</div>
                                <div style="width:22%;text-align: center;">单价</div>
                                <div style="width:23%;text-align: center;">金额</div>
                            </div>
                            `
            + strNew +
            `
                        </div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="display:flex;justify-content: space-between;margin-top:5px;">
                            <div >小计</div>
                            <div >${dataForm.orderInfo.num}</div>
                            <div >
                                ${tailFun(dataForm.orderInfo.receivables)}</div>
                        </div>
                        `
             +
            `
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        `
            +str33+ menberInfo+remarkInfo +
            `
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div style="margin-top:5px;line-height:5px;color:#e2e2e2;font-size:10px;">------------------------------------------------------</div>
                        <div>
                        `
             +
            `  
                            <div style="text-align:center;margin-top:5px;">${shopName2}</div>
                            <div style="text-align:center;margin-top:5px;">${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}</div>
                        `
            +
            `  
                        </div>
                       
                       `
                      +
                       `
                    </div>
                </body>
            ` //获取打印内容
        // LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml)
        // console.log('strFormHtml',strFormHtml);
        LODOP.PRINT_INIT("打印");
        LODOP.SET_PRINT_MODE("WINDOW_DEFPRINTER");
        LODOP.SET_PRINT_PAGESIZE(3, '58mm', 20, '');
        LODOP.ADD_PRINT_HTM(0, 0, '100%', "100%", strFormHtml)
        // LODOP.PREVIEW()
        
        LODOP.PRINT(); //打印模式
    }
};
var PrintLabelEvent1 = async function (dataForm,putNum?) {
    let LODOP = newLodop.getLodop("", "");
    LODOP.SET_LICENSES("", "7C892C1B4653971D8FC8694A6670808D9F9", "", "");
    if (LODOP) {
        LODOP.PRINT_INIT("打印");
        LODOP.SET_PRINT_MODE("WINDOW_DEFPRINTER");
       
        let paperSize = dataForm.paperSize;
        let padSetInfo = null;
        padSetInfo = dataForm.settingContent;
        const dx = 10;
        const dy = 10;
        let shopName = padSetInfo.shopName&&padSetInfo.shopName.value ?padSetInfo.shopName.value : JSON.parse(localStorage.getItem('padShopInfo')).shopName;
        let namePadding = shopName.length==1 ? 75 :shopName.length==2?75-(shopName.length-1)*10 :shopName.length<=4&&shopName.length>2?75-(shopName.length-2)*10:shopName.length<=11&&shopName.length>4? 75-(shopName.length-3)*10:0;
        namePadding = namePadding+5;
        /**40*30 */
        if(paperSize==1){
            let Nr30=await get30Nr(padSetInfo);
            console.log('Nr30',Nr30);
            
            let minHeight = Nr30.some(v=>v.value=='shopName')?0:12;
            
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '40mm', '30mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr30.forEach((rv,i)=>{
                    
                    if(rv.value=='shopName'){
                        LODOP.ADD_PRINT_TEXT(0,0 ,150,9,shopName);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
                    }else{
                        if(rv.value=='shortBarCode'){
                            let codeLength = v.shortBarCode&&(v.shortBarCode.length>4||!/^[0-9]*$/.test(v.shortBarCode))?130:100;
                            LODOP.ADD_PRINT_BARCODE(rv.index*15+minHeight, 5,codeLength,30,'128Auto',v.shortBarCode);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                            LODOP.SET_PRINT_STYLEA(0,"ShowBarText",0);//设置上面这个条码下方的文字字体大小
                        }else{
                            if(rv.value=='sellingPrice'){
                                let priceStr = rv.name=='零售价:￥'?'零售价:'+v[rv.value]+'元':rv.name+v[rv.value];
                                 LODOP.ADD_PRINT_TEXT(rv.index*15+minHeight,5 ,200,9,priceStr);
                                 LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+minHeight,5 ,200,9, rv.name+v[rv.value]);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                            }
                        }
                    }
                    
                })
               
                
          
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            
            // LODOP.PREVIEW()
            LODOP.PRINT()
        }else if(paperSize==2){
            /**40*60 */
            let Nr60=await get60Nr(padSetInfo);
            
            let minHeight = Nr60.some(v=>v.value=='shopName')?0:12;
         
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '40mm', '60mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr60.forEach((rv,i)=>{
                    
                    if(rv.value=='shopName'){
                        LODOP.ADD_PRINT_TEXT(0,0 ,150,9,shopName);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
                    }else{
                        if(rv.value=='shortBarCode'){
                            let codeLength = v.shortBarCode&&(v.shortBarCode.length>4||!/^[0-9]*$/.test(v.shortBarCode))?130:100;
                            let codeHeight= rv.name=='xs'?35:30;
                            LODOP.ADD_PRINT_BARCODE(rv.index*15+minHeight, 5,codeLength,codeHeight,'128Auto',v.shortBarCode);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                            if(rv.name!='xs'){
                                LODOP.SET_PRINT_STYLEA(0,"ShowBarText",0);
                            }
                        }else{
                            if(rv.value=='sellingPrice'){
                               let priceStr = rv.name=='￥'?v[rv.value]+'元':rv.name+v[rv.value];
                                 LODOP.ADD_PRINT_TEXT(rv.index*15+minHeight+20,5 ,200,9,priceStr);
                                 LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+minHeight,5 ,200,9, rv.name+v[rv.value]);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                            }
                        }
                    }
                    
                })
               
                
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            
            // LODOP.PREVIEW()
            LODOP.PRINT()
        }else if(paperSize==3){
            /**25*15 */
            let Nr20=await get20Nr(padSetInfo);
            let minHeight = Nr20.some(v=>v.value=='shopName')?0:12;
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '30mm', '76mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr20.forEach((rv,i)=>{
                    
                    if(rv.value=='shopName'){
                        LODOP.ADD_PRINT_TEXT(5,110,200,9,shopName);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                    }else{
                        if(rv.value=='shortBarCode'){
                            LODOP.ADD_PRINT_BARCODE(5 ,5,30,100,'128Auto',v.shortBarCode);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                            LODOP.SET_PRINT_STYLEA(0,"ShowBarText",0);//设置上面这个条码下方的文字字体大小
                            LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                        }else{
                            if(rv.value=='sellingPrice'){
                               let priceStr = rv.name=='￥'?v[rv.value]+'元':rv.name+v[rv.value];
                                 LODOP.ADD_PRINT_TEXT(5,110-rv.index*15-12 ,200,9,priceStr);
                                 LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                                 LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                LODOP.ADD_PRINT_TEXT(5,110-rv.index*15 ,200,9, v[rv.value]);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",9);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                        }
                    }
                    
                })
               
                
          
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            
            // LODOP.PREVIEW()
            LODOP.PRINT()
        }
        

    }
};
var PrintLabelEvent2 = async function (dataForm,putNum?,isFromMb?) {
    let LODOP = newLodop.getLodop("", "");
    LODOP.SET_LICENSES("", "7C892C1B4653971D8FC8694A6670808D9F9", "", "");
    if (LODOP) {
        LODOP.PRINT_INIT("打印");
        LODOP.SET_PRINT_MODE("WINDOW_DEFPRINTER");
       
        let paperSize = dataForm.paperSize;
        let padSetInfo = null;
        padSetInfo = dataForm.settingContent;
        const dx = 10;
        const dy = 10;
        const dy2 = 20;
        let shopName = JSON.parse(localStorage.getItem('padShopInfo')).shopName;
        
        /**40*30 */
        if(paperSize==1||paperSize==2||paperSize==3){
            let Nr30=await get30NrNew(padSetInfo.contentJson);
            console.log('Nr30',Nr30);
            
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '40mm', '30mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr30.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr30,i);
                    let BVal = chargeBeforeCode(Nr30,i);
                    let BValT = chargeBeforeCodeText(Nr30,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    if(rv.value=='shortBarCode'){
                        let xs = rv.infoIsShow?1:0;
                        let codeLength = value&&(value.length>4||!/^[0-9]*$/.test(value))?130:100;
                        let codeHeight= xs==1?35:30;
                        LODOP.ADD_PRINT_BARCODE(rv.index*15+hVal*15+BVal*18+BValT*5, 5,codeLength,codeHeight,'128Auto',v.shortBarCode);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                    LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,textBs,rv.name+value+rv.affName);
                                    LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                    let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                     break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                         
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+'/');
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else{
                           let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5,200,9, priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }
                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+value);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }
                    }
                    
                })
               
                
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            // LODOP.PREVIEW();
            LODOP.PRINT()
        }else if(paperSize==4){
            /**40*60 */
            let Nr60=await get60NrNew(padSetInfo.contentJson);
         
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '40mm', '60mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr60.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr60,i);
                    let BVal = chargeBeforeCode(Nr60,i);
                    let BValT = chargeBeforeCodeText(Nr60,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    if(rv.value=='shortBarCode'){
                        let codeLength = value&&(value.length>4||!/^[0-9]*$/.test(value))?130:100;
                        let xs = rv.infoIsShow?1:0;
                        let codeHeight= xs==1?35:30;
                        LODOP.ADD_PRINT_BARCODE(rv.index*15+hVal*15+BVal*18+BValT*5+5, 5,codeLength,codeHeight,'128Auto',v.shortBarCode);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,textBs,rv.name+value+rv.affName);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                    break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                         
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                }else{
                                    LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9, rv.name+'/');
                                    LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                }
                            }else{
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5,200,9, priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }

                        }else if(rv.value=='xdTip'){
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9, rv.defaultVal);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9, rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9, rv.name+value);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }
                    }
                    
                })
               
                
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            
            // LODOP.PREVIEW()
            LODOP.PRINT()
        }else if(paperSize==7){
            /**25*15 */
            let Nr20=await get30NrNew(padSetInfo.contentJson);
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '30mm', '76mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr20.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr20,i);
                    let BVal = chargeBeforeCode(Nr20,i);
                    let BValT = chargeBeforeCodeText(Nr20,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    let fmH=i>2?10:0;
                    
                    if(rv.value=='shortBarCode'){
                        let str = isFromMb?'0002':value;
                        let xs = rv.infoIsShow?1:0;
                        LODOP.ADD_PRINT_BARCODE(5,(75-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7,30,100,'128Auto',str);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                        LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                let str = rv.name+value+rv.affName;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,str);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                    break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,rv.name+'/');
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                                
                            }
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                            

                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                let str = rv.name+value;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,str);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                        }
                    }
                   
                    
                })
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
            })
            
            // LODOP.PREVIEW()
            LODOP.PRINT()
        }else if(paperSize==5){
            /**30*20 */
            let Nr30=await get30NrNew(padSetInfo.contentJson);
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '30mm', '20mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr30.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr30,i);
                    let BVal = chargeBeforeCode(Nr30,i);
                    let BValT = chargeBeforeCodeText(Nr30,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    if(rv.value=='shortBarCode'){
                        let str = isFromMb?'0002':value;
                        let xs = rv.infoIsShow?1:0;
                        // let codeLength = str&&(str.length>4||!/^[0-9]*$/.test(str))?160:100;
                        LODOP.ADD_PRINT_BARCODE(rv.index*15+hVal*15+BVal*18+BValT*5, 5,100,30,'128Auto',str);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                    LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,textBs,rv.name+value+rv.affName);
                                    LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                    let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                     break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                         
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+'/');
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else{
                           let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5,200,9, priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }
                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+value);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }
                    }
                    
                })
               
                
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            // LODOP.PREVIEW();
            LODOP.PRINT()
        }else if(paperSize==6){
            /**25*15 */
            let Nr30=await get30NrNew(padSetInfo.contentJson);
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '25mm', '15mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr30.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr30,i);
                    let BVal = chargeBeforeCode(Nr30,i);
                    let BValT = chargeBeforeCodeText(Nr30,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    if(rv.value=='shortBarCode'){
                        let str = isFromMb?'0002':value;
                        let xs = rv.infoIsShow?1:0;
                        LODOP.ADD_PRINT_BARCODE(rv.index*15+hVal*15+BVal*18+BValT*5+5, 5,100,30,'128Auto',str);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                    LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,textBs,rv.name+value+rv.affName);
                                    LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                    let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                     break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                         
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9, rv.name+'/');
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else{
                           let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5,200,9, priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }
                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9, rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(rv.index*15+hVal*15+BVal*18+BValT*5+5,5 ,200,9, rv.name+value);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }
                    }
                    
                })
               
                
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            // LODOP.PREVIEW();
            LODOP.PRINT()
        }else if(paperSize==8){
            /**30*75 */
            let Nr30=await get30NrNew(padSetInfo.contentJson);
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '30mm', '75mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr30.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr30,i);
                    let BVal = chargeBeforeCode(Nr30,i);
                    let BValT = chargeBeforeCodeText(Nr30,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    let fmH=i>2?6:0;
                    if(rv.value=='shortBarCode'){
                        let str = isFromMb?'0002':value;
                        let xs = rv.infoIsShow?1:0;
                        LODOP.ADD_PRINT_BARCODE(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5, 5,100,30,'128Auto',str);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                    LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,textBs,rv.name+value+rv.affName);
                                    LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                    let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                     break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                         
                                LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+'/');
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }else{
                           let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5,200,9, priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                        }
                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }else{
                                LODOP.ADD_PRINT_TEXT(180+fmH+rv.index*15+hVal*15+BVal*18+BValT*5,5 ,200,9, rv.name+value);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            }
                        }
                    }
                    
                })
               
                
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
                
            })
            // LODOP.PREVIEW();
            LODOP.PRINT()
        }else if(paperSize==9){
            /**25*15 */
            let Nr20=await get30NrNew(padSetInfo.contentJson);
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '30mm', '70mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr20.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr20,i);
                    let BVal = chargeBeforeCode(Nr20,i);
                    let BValT = chargeBeforeCodeText(Nr20,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    let fmH=i>2?5:0;
                    
                    if(rv.value=='shortBarCode'){
                        let str = isFromMb?'0002':value;
                        let xs = rv.infoIsShow?1:0;
                        LODOP.ADD_PRINT_BARCODE(5,(75-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-5,30,100,'128Auto',str);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                        LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                let str = rv.name+value+rv.affName;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,str);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                    break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,rv.name+'/');
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                                
                            }
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                            

                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                let str = rv.name+value;
                                LODOP.ADD_PRINT_TEXT(5,(110-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7-10 ,200,textBs,str);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                        }
                    }
                   
                    
                })
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
            })
            
            // LODOP.PREVIEW()
            LODOP.PRINT()
        }else if(paperSize==10){
            /**25*15 */
            let Nr20=await get30NrNew(padSetInfo.contentJson);
            dataForm.orderInfoArr.forEach((v,vindex)=>{
            LODOP.NewPage();
            LODOP.SET_PRINT_PAGESIZE(1, '50mm', '20mm', 'LodopCustomPage');
                let num = putNum*(v.number?v.number:1);
                Nr20.forEach((rv,i)=>{
                    let textBs = rv.size;
                    let hVal = chargeBeforeText(Nr20,i);
                    let BVal = chargeBeforeCode(Nr20,i);
                    let BValT = chargeBeforeCodeText(Nr20,i);
                    let value = rv.dataType==1?v[rv.value]:rv.defaultVal;
                    let fmH=i>2?10:0;
                    
                    if(rv.value=='shortBarCode'){
                        let str = isFromMb?'0002':value;
                        let xs = rv.infoIsShow?1:0;
                        LODOP.ADD_PRINT_BARCODE(5,(145-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7,30,70,'128Auto',str);
                        LODOP.SET_PRINT_STYLEA(0,"FontSize",5);//设置上面这个条码下方的文字字体大小
                        LODOP.SET_PRINT_STYLEA(0,"ShowBarText",xs);
                        LODOP.SET_PRINT_STYLEA(0, "AlignJustify", 1);
                        LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                    }else{
                        if(rv.value=='sellingPrice'){
                            if(rv.labelTemplateDataType==2){
                                let str = rv.name+value+rv.affName;
                                LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,str);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                        }else if(rv.value=='discountPrice'){
                            let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                            LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                            LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                            LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                        }else if(rv.value=='memberPriceRange'){
                            if(rv.dataType==1){
                                let vipprice_l="";
                            let vipprice_r="";
                            let priceStr= "";                          
                            if (v[rv.value]) {
                                if (v[rv.value].indexOf("-") != -1) {
                                    vipprice_l = v[rv.value].split("-")[0];
                                    vipprice_r = v[rv.value].split("-")[1];
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    vipprice_r =
                                        vipprice_r.split(".")[0].length == 0
                                            ? "0" + vipprice_r
                                            : vipprice_r;
                                } else {
                                    vipprice_l = v[rv.value];
                                    vipprice_r = "";
                                    vipprice_l =
                                        vipprice_l.split(".")[0].length == 0
                                            ? "0" + vipprice_l
                                            : vipprice_l;
                                    if (v[rv.value].length == 0) {
                                        vipprice_l = "0.00";
                                    }
                                }
                            } else {
                                vipprice_l = "0.00";
                                vipprice_r = "";
                            }
                            switch (rv.defaultVal) {
                                case '1':
                                    let maxval=vipprice_r?vipprice_r:vipprice_l;
                                     priceStr = rv.fh=='¥'?rv.name+maxval+'元':rv.name+rv.fh+maxval;
                                    break;
                                case '2':
                                     priceStr = rv.fh=='¥'?rv.name+vipprice_l+'元起':rv.name+rv.fh+vipprice_l+'起';
                                    break;
                                case '3':
                                let nnstr = vipprice_r&&Number(vipprice_r)>0?rv.name+vipprice_l+'元'+'-'+vipprice_r+'元':rv.name+vipprice_l+'元';
                                    let nnstr2 = vipprice_r&&Number(vipprice_r)>0?rv.name+rv.fh+vipprice_l+'-'+rv.fh+vipprice_r:rv.name+rv.fh+vipprice_l;
                                     priceStr = rv.fh=='¥'?nnstr:nnstr2;
                                    break;
                            
                                default:
                                    break;
                            }
                            if(v.isMemberDiscount){
                                LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,rv.name+'/');
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                                
                            }
                            }else{
                                let priceStr = rv.fh=='¥'?rv.name+value+'元':rv.name+rv.fh+value;
                                LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,priceStr);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                            

                        }else{
                            if(rv.value=='shopName'){
                                let shopNamew = rv.defaultVal?rv.defaultVal:shopName;
                                LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,rv.name+shopNamew);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }else{
                                let str = rv.name+value;
                                LODOP.ADD_PRINT_TEXT(5,(180-rv.index*15)-hVal*15-BVal*20-fmH-BValT*7 ,200,textBs,str);
                                LODOP.SET_PRINT_STYLEA(0,"FontSize",textBs);//设置上面这个条码下方的文字字体大小
                                LODOP.SET_PRINT_STYLEA(0, "Angle", 270);
                            }
                        }
                    }
                   
                    
                })
                LODOP.SET_PRINT_MODE("PRINT_START_PAGE",1);
                LODOP.SET_PRINT_MODE("PRINT_END_PAGE",1);
                LODOP.SET_PRINT_COPIES(num); 
            })
            
            // LODOP.PREVIEW()
            LODOP.PRINT()
        }
        

    }
};
function getPrintList() {
    let LODOP = newLodop.getLodop("", "");

    let count = LODOP.GET_PRINTER_COUNT();
    let array = [];
    for (let k = 0; k < count; k++) {
        let msg = LODOP.GET_PRINTER_NAME(k);
        console.log('打印机名称',msg)
        if (msg == 'HPRT D25BT(ESC)') {
            LODOP.SET_PRINTER_INDEX(k); //设置默认打印机
        }
    }
}

export { PrintEvent1, PrintEvent2,PrintEvent3,PrintLabelEvent1,PrintLabelEvent2,PrintEvent4 };


// WEBPACK FOOTER //
// ./src/common/util/prints.ts